import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { format } from "date-fns";
import Menu, { Item as MenuItem } from "rc-menu";
import "rc-dropdown/assets/index.css";
import Dropdown from "rc-dropdown";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { ModalBanner } from "../../assets";
import BaseModal from "./baseModal/BaseModal";
import { GET_HTML } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";


class ParentCreditsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      amount: "",
      message: "", 
      //creditData: null,
      //creditHistory: [],
      loading: false, 
      selectedCredit: null,
      stripeBalance: 0, 
      stripeTransactions: [],
      featureLimit: 100
    };
    this.submitForm = this.submitForm.bind(this);
  }

  async componentDidMount() {
    try {
      console.log("Component mounted, selectedItem:", this.props.selectedItem);

      const featureLimitResponse = await axios.get(
        `${process.env.REACT_APP_API}/partner/permissions/credits`
      );

      const stripeResponse = await axios.get(`${process.env.REACT_APP_API}/par/orders/stripe-customer-balance?dsUserId=${this.props.selectedItem.dsUserId}&partnerId=${this.props.selectedItem.partnerId}`);      
      /*
      if (stripeResponse.data.success) {
        //console.log("Credit data response:", response.data.data);
        //console.log("Selected user ID:", this.props.selectedItem.dsUserId);
        const userCredit = creditResponse.data.data.find(
           credit => Number(credit.dsUserId) === Number(this.props.selectedItem.dsUserId)
        );
        //console.log("Found user credit:", userCredit);
        this.setState({ 
          creditData: userCredit,
          creditHistory: creditResponse.data.data.filter(
            credit => Number(credit.dsUserId) === Number(this.props.selectedItem.dsUserId)
          )
        });
        //console.log("credit history", this.state.creditHistory);
      }*/

      if (stripeResponse.data.success && featureLimitResponse.data.success) {
        this.setState({
          stripeBalance: stripeResponse.data.data.balance || 0,
          stripeTransactions: Array.isArray(
            stripeResponse.data.data.balanceTransactions
          )
            ? stripeResponse.data.data.balanceTransactions
            : [],
          featureLimit: featureLimitResponse.data.permission?.featureLimit || 100
        });
      }
    } catch (error) {
      console.error("Error fetching credit data:", error);
    }
  }

  async submitForm(e, type, selectedCredit = null) {
    if (e) {
      e.preventDefault();
    }
    if (this.state.loading) return;

    let amount;
    let message;

    if (type === 'remove') {
      //console.log("selectedCredit", selectedCredit);
      amount = -selectedCredit.amount;
      message = `Removed credit: ${selectedCredit.description}`;
    } else {
      amount = parseInt(this.state.amount * 100);
      message = this.state.message;
    }

    if(type === 'add'){
      if (!this.state.amount) {
        toast.error("Please enter a credit amount!");
        return;
      }
      if (!this.state.message) {
        toast.error("Please enter a message!");
        return;
      }
      if (this.state.message.length > 255) {
        toast.error("Message is too long.");
        return;
      }
      if (amount > this.state.featureLimit * 100) {
        toast.error(`Credit amount cannot exceed $${this.state.featureLimit}`);
        return;
      }
    }
    this.setState({ loading: true });

    try {
      const ep = `${process.env.REACT_APP_API}/par/orders/credit`;
      const res = await axios.post(ep, {
        dsUserId: this.props.selectedItem.dsUserId,
        partnerId: this.props.selectedItem.partnerId, 
        amount: amount,
        reason: message,
        expiresAt: null, 
        action: type, 
        selectedCredit: type === 'remove' ? {
          id: selectedCredit.id,
          customerId: selectedCredit.customer,
          amount: selectedCredit.amount,
          description: selectedCredit.description,
          metadata: selectedCredit.metadata
        } : null
      });

      if (res.data.success) {
        toast.success(`Credit ${type === 'remove' ? 'removed' : 'added'} successfully!`);
        this.props.onClose();
        if (this.props.refresh) {
          this.props.refresh();
        }
      } else {
        toast.error(res.data.message || `Failed to ${type} credit`);
      }
    } catch (error) {
      toast.error("An error occurred while issuing the credit");
    } finally {
      this.setState({ loading: false });
    }
  }

  onCreditSelect = async (credit, event) => {
    if (event.key === "view") {
      this.setState({ selectedCredit: credit });
    } else if (event.key === "remove") {
      await this.submitForm(null, 'remove', credit);
    }
  };

  creditMenu = (transaction) => {
    return (
      <Menu onClick={event => this.onCreditSelect(transaction, event)} selectable={false}>
        <MenuItem key="view">View Message</MenuItem>
        <MenuItem key="remove">Remove Credit</MenuItem>
      </Menu>
    );
  };

  displayModalData = () => {
    return (
      <div>
        <form onSubmit={(e) => this.submitForm(e, 'add')}>
          <div
            className="form-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}
          >
            <label
              htmlFor="amount"
              style={{
                width: "25%",
                textAlign: "left",
                fontSize: "1.15rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "500",
                color: "#626262"
              }}
            >
              Amount
            </label>
            <input
              type="number"
              id="amount"
              name="amount"
              step="0.01"
              placeholder="Enter amount ($)"
              value={this.state.amount}
              onChange={e => this.setState({ amount: e.target.value })}
              style={{
                width: "70%",
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>

          <div
            className="form-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}
          >
            <label
              htmlFor="message"
              style={{
                width: "25%",
                textAlign: "left",
                fontSize: "1.15rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "500",
                color: "#626262"
              }}
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="Enter reason for adding credit"
              value={this.state.message}
              onChange={e => this.setState({ message: e.target.value })}
              style={{
                width: "70%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                minHeight: "100px",
                resize: "vertical",
                fontSize: "0.9rem"
              }}
              required
            />
          </div>

          <div style={{ textAlign: "right" }}>
            <button
              type="submit"
              disabled={this.state.loading}
              style={{
                backgroundColor: BLUE_BUTTON,
                color: WHITE,
                padding: "6px 16px",
                cursor: this.state.loading ? "not-allowed" : "pointer", 
                fontSize: "1.2rem", 
                borderRadius: "6px",
                border: "none"
              }}
            >
              {this.state.loading ? "Processing..." : "Add Credit"}
            </button>
          </div>
        </form>

        {this.state.stripeTransactions.length > 0 && (
          <div style={{ marginTop: "30px" }}>
            <h3 style={{ 
              marginBottom: "20px",
              fontSize: "1.5rem",
              fontFamily: "futura-pt, sans-serif",
              fontWeight: "500",
              color: "#626262"
            }}>Credit History</h3>
            <table className="table">
              <thead
                style={{
                  color: "#A9A9A9",
                  fontSize: "12.5px",
                  fontFamily: "futura-pt, sans-serif",
                  fontWeight: "500",
                  textAlign: "left",
                  borderBottom: "1px solid gainsboro"
                }}
              >
                <tr>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {[...this.state.stripeTransactions]
                .filter(transaction =>transaction.metadata?.hidden !== "true")
                  .sort((a, b) => new Date(b.created) - new Date(a.created))
                  .map((transaction, i) => (
                    <tr
                      key={i}
                      style={{
                        fontSize: "12px",
                        color: "#959595",
                        borderBottom: "2px solid gainsboro"
                      }}
                    >
                      <td>
                        {(parseFloat(-transaction.amount) / 100).toLocaleString('en-CA', {
                          style: "currency",
                          currency: "CAD"
                        })}
                      </td>
                      <td>
                        <p style={{ margin: 0 }}>{format(new Date(transaction.created * 1000), "PPP")}</p>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {this.getDropdownMenu(this.creditMenu(transaction))}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  getDropdownMenu = (menu) => {
    return (
      <Dropdown
        trigger={["click"]}
        overlay={menu}
        animation="slide-up"
        overlayStyle={{ 
          zIndex: 9999,
          position: 'fixed' 
        }}
        getPopupContainer={() => document.body} 
      >
        <button
          style={{
            borderRadius: "50%",
            width: 20,
            height: 20,
            minWidth: 20,
            minHeight: 20,
            outline: "none",
            border: 0,
            background: "#f4f6fd",
            fontSize: "14px",
            cursor: "pointer"
          }}
        >
          <i className="fas fa-ellipsis-v"></i>
        </button>
      </Dropdown>
    );
  };

  getBaseModalFields = () => {
    const infoFields = {
      type: GET_HTML,
      data: {
        gethtml: this.displayModalData
      }
    };

    const fields = [];
    fields.push(infoFields);
    return fields;
  };

  getBaseModalButtons = () => {};

  getBaseModalProps = () => {
    const formattedCredit =
      (parseFloat(-this.state.stripeBalance) / 100).toLocaleString('en-CA', {
        style: "currency",
        currency: "CAD"
      });

    return {
      title: `Total Credit: ${formattedCredit}`,
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      handleClose: this.props.onClose,
      height: "65vh",
      midSectionHeight: "49vh"
    };
  };

  render() {
    return (
      <div>
        {this.state.selectedCredit && (
          <div className="request-modal-cont">
            <div className="request-modal lesspadding">
              <div style={{ display: "block" }}>
                <img
                  src={ModalBanner}
                  alt="Modal Banner"
                  style={{
                    height: "40px",
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "48px"
                  }}
                >
                  <h3>Credit Message</h3>
                  <IconButton
                    style={{
                      borderRadius: "50%",
                      color: "#2880FF",
                      marginBottom: "1rem"
                    }}
                    onClick={() => this.setState({ selectedCredit: null })}
                  >
                    <Close />
                  </IconButton>
                </div>
                <div style={{ padding: "20px" }}>
                  <p style = {{
                    fontSize: "1.2rem", 
                    fontFamily: "futura-pt, sans-serif", 
                    fontWeight: "500", 
                    color: "#626262"}}>
                      {this.state.selectedCredit.description}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {!this.state.selectedCredit && <BaseModal {...this.getBaseModalProps()} />}
      </div>
    );
  }
}

export default ParentCreditsModal;
